import { i18n } from '@/i18n';
import type { MeterIssueTypeJson } from '@/data/meters/MeterIssueJson.ts';
import { useMeterIssueTypeStore } from '@/stores/MeterIssueTypeStore.ts';

// Descriptions come from the Metropolis /meter-issue-types endpoint
// (see MeterIssueApi.getAllTypes()). The fallback key covers types the
// endpoint doesn't know: frontend-only filter entries (shade, power_spike,
// new, ticket, misc), MetricValues entries, and the moment before the
// types have been fetched.

function findType(typeName: string): MeterIssueTypeJson | null {
  const types = useMeterIssueTypeStore().types;
  return types?.find((type) => type.name === typeName) ?? null;
}

function description(
  typeName: string,
  displayNamePrefix: string,
  fallbackKey?: string,
): string {
  const type = findType(typeName);
  if (type) {
    return type[displayNamePrefix + i18n.global.locale] ?? '';
  }
  return fallbackKey ? i18n.global.t(fallbackKey) : '';
}

export function issueShortDescription(
  typeName: string,
  fallbackKey?: string,
): string {
  return description(typeName, 'display_name_short_', fallbackKey);
}

export function issueLongDescription(
  typeName: string,
  fallbackKey?: string,
): string {
  return description(typeName, 'display_name_', fallbackKey);
}
